import styled, { keyframes } from "styled-components";

const HeaderKeyFrame = keyframes`
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
`;

const AuthWrapper = styled.div`
  min-height: 100vh;
  min-width:100vw;
  background:radial-gradient(ellipse at top, #142b22, #000000),radial-gradient(ellipse at bottom, #000000, transparent);
  animation: ${HeaderKeyFrame} 10s ease infinite;
  background-size: 200% 100%;
  }
`;

export { AuthWrapper };
